import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'cz-upload-wait',
    templateUrl: './upload-wait.component.html',
    styleUrls: ['./upload-wait.component.css'],
    standalone: false
})
export class UploadWaitComponent {

  @Input() popupVisible: boolean;
  @Input() toUpload: number;
  @Input() isUploaded: number;
  @Input() uploadFileName: string = '';

  @Output() onCancel: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    this.onClickClose = this.onClickClose.bind(this);
   }

  onClickClose() {
    this.onCancel.emit(true);
    this.popupVisible = false;
  }
}
